import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=649d9e3f&scoped=true&"
import script from "./mainLayout.vue?vue&type=script&lang=js&"
export * from "./mainLayout.vue?vue&type=script&lang=js&"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=649d9e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d9e3f",
  null
  
)

export default component.exports